import GroupScreen from '../../components/layout/group-screen';
import { JOB_NAMES } from '../../constants/jobNames';
import ErrorAnalytics from '../error-analytics/error-analytics';
import LogTransactionList from '../log-transaction/log-transaction-list';
import BackgroundJobDashboard from '../background-jobs/tabs/dashboard-view';
import NotificationRunList from '../notification-runs/notification-run-list';
import FeedbackDashboard from '../feedback/feedback-dashboard';

/** Logs — merged screen for the application, error and transaction log views. */
const LogsGroup = () => (
  <GroupScreen
    icon="repeat-2"
    iconBgColor="bg-slate-600"
    title="Transactional Dashboard"
    subtitle="Application, error, audit and notification dashboards"
    testId="SCR-LogsGroup"
    tabs={[
      // Error Analytics dashboard, not the legacy monitor — the monitor is still
      // reachable on its own at /error-logs-monitor.
      { key: 'error-logs', header: 'Error Dashboard', leftIcon: 'alert-triangle', jobs: [JOB_NAMES.ERROR_LOGS], element: <ErrorAnalytics /> },
      { key: 'transaction', header: 'Audit Log Dashboard', leftIcon: 'file-chart', jobs: [JOB_NAMES.LOG_TRANSACTION], element: <LogTransactionList /> },
      // The record of what the notification engine actually fired — moved here
      // from the Notification Engine screen so every "what happened" view is
      // together on the dashboard.
      { key: 'notifications', header: 'Notifications', leftIcon: 'bell', jobs: [JOB_NAMES.NOTIFICATION_RUNS], element: <NotificationRunList embedded /> },
      // The same component the Background Jobs screen opens on, surfaced here so
      // every operational dashboard is reachable from one place. Gated on
      // BACKGROUND_JOB.READ, exactly as it is there — sharing the component keeps
      // the two entry points from drifting apart.
      { key: 'background-job-dashboard', header: 'Background Job Dashboard', leftIcon: 'file-cog', jobs: [JOB_NAMES.BACKGROUND_JOB], element: <BackgroundJobDashboard /> },
      // What users said about the product, beside what the system did about it.
      // Gated on FEEDBACK_SUBMISSION.READ, the same grant the Feedback screen's
      // submission list uses — this is the same data, aggregated.
      { key: 'feedback-dashboard', header: 'Feedback Dashboard', leftIcon: 'message-dots', jobs: [JOB_NAMES.FEEDBACK_SUBMISSION], element: <FeedbackDashboard /> },
    ]}
  />
);

export default LogsGroup;
